var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatepickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64444 1.62102C6.07327 1.59121 6.39229 1.76048 6.60147 2.12884C6.65839 2.79018 6.67792 3.45424 6.66007 4.12102C8.87362 4.12102 11.0871 4.12102 13.3007 4.12102C13.2828 3.45424 13.3024 2.79018 13.3593 2.12884C13.6703 1.6327 14.0934 1.50901 14.6288 1.75774C14.7847 1.8745 14.8954 2.02424 14.9608 2.20696C14.9804 2.84485 14.9869 3.48287 14.9804 4.12102C15.4925 4.09884 16.0003 4.13138 16.5038 4.21868C17.5457 4.57083 18.1512 5.29349 18.3202 6.38665C18.3398 6.75099 18.3462 7.11559 18.3398 7.4804C12.7668 7.4804 7.19393 7.4804 1.621 7.4804C1.59881 6.96829 1.63137 6.46048 1.71866 5.95696C2.07178 4.91399 2.79443 4.30852 3.88663 4.14056C4.25097 4.12102 4.61557 4.11454 4.98038 4.12102C4.97386 3.48287 4.98038 2.84485 4.99991 2.20696C5.12483 1.90597 5.33968 1.71066 5.64444 1.62102Z",
    fill: "#464E5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62061 9.12109C7.19354 9.12109 12.7664 9.12109 18.3394 9.12109C18.3459 11.4388 18.3394 13.7566 18.3198 16.0742C18.1169 17.3709 17.3682 18.1196 16.0737 18.3203C12.0112 18.3464 7.94873 18.3464 3.88623 18.3203C2.58958 18.1174 1.84089 17.3687 1.64014 16.0742C1.62061 13.7566 1.61409 11.4388 1.62061 9.12109Z",
    fill: "#464E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepickerIcon);
export default __webpack_public_path__ + "static/media/datepicker-icon.0b6d333da5da98b018d0a9cdd428de51.svg";
export { ForwardRef as ReactComponent };